import { FC } from 'react';
import { Input } from 'antd';
import BaseItem, { BaseItemProps } from './BaseItem';

interface InputItemProps extends BaseItemProps {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const InputItem: FC<InputItemProps> = (props) => {
  const { onChange, ...rest } = props;
  return (
    <BaseItem {...rest}>
      <Input onChange={onChange} />
    </BaseItem>
  );
};

export default InputItem;
